// tippi/src/pages/carrier/NewVehiclePage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import { useCarrierMembers } from '../../hooks/useCarrierMembers';
import VehicleForm from './VehicleForm';
import { ui } from './carrierStyles';

export default function NewVehiclePage() {
  const navigate = useNavigate();
  const { loading, orgId, isStaff } = useCarrierOrg();
  const { members } = useCarrierMembers(orgId);
  const drivers = members.filter(m => m.role === 'driver' && m.status === 'active').map(m => ({ id: m.id, name: m.name }));

  if (loading) return null;
  if (!isStaff) return <p style={ui.hint}>Bare administratorer og dispatchere kan legge til biler.</p>;

  return (
    <>
      <h1 style={ui.h1}>Ny bil</h1>
      <div style={ui.card}>
        <VehicleForm
          orgId={orgId}
          drivers={drivers}
          onSaved={(id) => navigate(`/transportor/biler/${id}`)}
          onCancel={() => navigate('/transportor/biler')}
        />
      </div>
    </>
  );
}
